import { render } from "./SpeakerTable.vue?vue&type=template&id=c6510fdc"
import script from "./SpeakerTable.vue?vue&type=script&lang=ts"
export * from "./SpeakerTable.vue?vue&type=script&lang=ts"
script.render = render

export default script